module.exports = __webpack_public_path__ + "static/img/hz-barnner.0964e27f.jpg";